
const ContactDataKey = 'safecube-booking-contact-data';
interface ContactData {
	name: string;
	email: string;
	phone: string;
}

export function useLocalStorage() {

	return {
		getContactData: () => {
			const json = localStorage.getItem(ContactDataKey);
			return json !== null ? JSON.parse(json) as ContactData : undefined;
		},
		setContactData: (data: ContactData) => {
			localStorage.setItem(ContactDataKey, JSON.stringify(data));
		}
	}
}
